import styled from "styled-components";
import { rgba } from "polished";
const TabWrapper = styled("div").attrs({ role: "presentation" })({
  position: "relative",
  borderRadius: "inherit"
});
const TabImpl = styled("div").attrs(({ selected }) => ({
  "aria-selected": selected || void 0,
  role: "tab",
  tabIndex: 0
}))(
  ({ theme }) => ({
    borderColor: theme.borderColor,
    borderRadius: "inherit",
    borderStyle: "solid",
    borderWidth: 1,
    display: "flex",
    fontSize: theme.fontSize.default,
    lineHeight: theme.lineHeight.lg,
    outline: 0,
    padding: "4px 8px",
    position: "relative",
    whiteSpace: "nowrap",
    width: "min-content",
    "&, &:hover, &:active, &:focus": {
      color: theme.color.default
    },
    "&:focus": {
      boxShadow: `0 0 0 2px ${rgba("black", 0.05)}`,
      zIndex: 2
    }
  }),
  ({ selected, theme }) => selected ? {
    backgroundColor: "white",
    borderBottomColor: "transparent",
    cursor: "default",
    paddingBottom: 4
  } : {
    backgroundColor: theme.color.gray2,
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.05)"
    },
    "&:active": {
      backgroundColor: theme.color.gray4
    }
  }
);
const TabInner = styled.div(({ hasMenu }) => ({
  paddingRight: hasMenu ? 48 : 0
}));
export {
  TabImpl,
  TabInner,
  TabWrapper
};
